import { Injectable } from '@angular/core';
import {BaseService, httpOptions} from "@core/service/base.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ArticleViewService extends BaseService{
  private url = 'api/view-record';

  constructor(http:HttpClient) {
    super(http);
  }

  getUrl():string {
    return this.url;
  }

  getPage(object:any):Observable<any> {
    return this.http.post<any>(this.getUrl() + '/page', object, httpOptions).pipe(
      tap((object:any) => this.log(`getPage`)),
      catchError(this.handleError<any>('getPage'))
    );
  }

  addFk(object:any):Observable<any> {
    return this.http.post<any>('api/view-record?_allow_anonymous=true', object, httpOptions).pipe(
      tap((object:any) => this.log(`added object =${object}`)),
      catchError(this.handleError<any>('addany'))
    );
  }

//  根据文章id获取关联的寻源项目详情
  getSourceByArticleId(id):Observable<any> {
    const url = `api/sourcing-article/by-article`;
    return this.http.get<any>(url, {params: {articleId:id}}).pipe(
      tap(_ => this.log(`getSourceByArticleId`)),
      catchError(this.handleError<any>(`getSourceByArticleId`))
    );
  }
}
